import React from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {NAVY, TEXTE, TITRE_SECTION} from '../../tokens.js';

const lienSx = {color: NAVY, textDecoration: 'none', fontWeight: 600, '&:hover': {textDecoration: 'underline'}};

/** Fil d'Ariane `Carte › Commune › Nomenclature` (R8). `communeTo` absent : la commune est affichée sans lien. */
export default function FicheFilAriane({carteTo, communeLibelle, communeTo, nomenclature}) {
    return (
        <Box component="nav" aria-label="Fil d'Ariane" sx={{display: 'flex', alignItems: 'center', gap: '8px', fontSize: 13, color: TITRE_SECTION}}>
            <Box component={Link} to={carteTo} sx={lienSx}>Carte</Box>
            {communeLibelle && (
                <>
                    <ChevronRightIcon sx={{fontSize: 14}}/>
                    {communeTo
                        ? <Box component={Link} to={communeTo} sx={lienSx}>{communeLibelle}</Box>
                        : <Box component="span">{communeLibelle}</Box>}
                </>
            )}
            <ChevronRightIcon sx={{fontSize: 14}}/>
            <Box component="span" sx={{color: TEXTE, fontWeight: 700}}>{nomenclature}</Box>
        </Box>
    );
}
